const boyMuacThresholds = [
  { minAge: 3, maxAge: 3, green: 11.6, yellow: 10.7 },
  { minAge: 4, maxAge: 4, green: 11.8, yellow: 10.9 },
  { minAge: 5, maxAge: 5, green: 12, yellow: 11.1 },
  { minAge: 6, maxAge: 6, green: 12.2, yellow: 11.3 },
  { minAge: 7, maxAge: 7, green: 12.3, yellow: 11.4 },
  { minAge: 8, maxAge: 8, green: 12.4, yellow: 11.4 },
  { minAge: 9, maxAge: 9, green: 12.4, yellow: 11.5 },
  { minAge: 10, maxAge: 10, green: 12.5, yellow: 11.5 },
  { minAge: 11, maxAge: 12, green: 12.5, yellow: 11.6 },
  { minAge: 13, maxAge: 14, green: 12.6, yellow: 11.6 },
  { minAge: 15, maxAge: 15, green: 12.6, yellow: 11.7 },
  { minAge: 16, maxAge: 17, green: 12.7, yellow: 11.7 },
  { minAge: 18, maxAge: 18, green: 12.7, yellow: 11.8 },
  { minAge: 19, maxAge: 19, green: 12.8, yellow: 11.8 },
  { minAge: 20, maxAge: 21, green: 12.8, yellow: 11.9 },
  { minAge: 22, maxAge: 22, green: 12.9, yellow: 11.9 },
  { minAge: 23, maxAge: 23, green: 12.9, yellow: 12 },
  { minAge: 24, maxAge: 24, green: 13, yellow: 12 },
  { minAge: 25, maxAge: 25, green: 13, yellow: 12.1 },
  { minAge: 26, maxAge: 26, green: 13.1, yellow: 12.1 },
  { minAge: 27, maxAge: 27, green: 13.1, yellow: 12.2 },
  { minAge: 28, maxAge: 28, green: 13.2, yellow: 12.2 },
  { minAge: 29, maxAge: 29, green: 13.2, yellow: 12.3 },
  { minAge: 30, maxAge: 31, green: 13.3, yellow: 12.3 },
  { minAge: 32, maxAge: 32, green: 13.3, yellow: 12.4 },
  { minAge: 33, maxAge: 35, green: 13.4, yellow: 12.4 },
  { minAge: 36, maxAge: 39, green: 13.5, yellow: 12.5 },
  { minAge: 40, maxAge: 44, green: 13.6, yellow: 12.6 },
  { minAge: 45, maxAge: 48, green: 13.7, yellow: 12.7 },
  { minAge: 49, maxAge: 50, green: 13.8, yellow: 12.7 },
  { minAge: 51, maxAge: 53, green: 13.8, yellow: 12.8 },
  { minAge: 54, maxAge: 56, green: 13.9, yellow: 12.8 },
  { minAge: 57, maxAge: 58, green: 13.9, yellow: 12.9 },
  { minAge: 59, maxAge: 60, green: 14, yellow: 12.9 },
];

const girlMuacThresholds = [
  { minAge: 3, maxAge: 3, green: 11.1, yellow: 10.2 },
  { minAge: 4, maxAge: 4, green: 11.3, yellow: 10.5 },
  { minAge: 5, maxAge: 5, green: 11.5, yellow: 10.7 },
  { minAge: 6, maxAge: 6, green: 11.7, yellow: 10.8 },
  { minAge: 7, maxAge: 7, green: 11.8, yellow: 10.9 },
  { minAge: 8, maxAge: 9, green: 11.9, yellow: 11 },
  { minAge: 10, maxAge: 11, green: 12, yellow: 11.1 },
  { minAge: 12, maxAge: 12, green: 12.1, yellow: 11.1 },
  { minAge: 13, maxAge: 14, green: 12.1, yellow: 11.2 },
  { minAge: 15, maxAge: 16, green: 12.2, yellow: 11.3 },
  { minAge: 17, maxAge: 18, green: 12.3, yellow: 11.4 },
  { minAge: 19, maxAge: 19, green: 12.4, yellow: 11.4 },
  { minAge: 20, maxAge: 20, green: 12.4, yellow: 11.5 },
  { minAge: 21, maxAge: 21, green: 12.5, yellow: 11.6 },
  { minAge: 22, maxAge: 22, green: 12.6, yellow: 11.6 },
  { minAge: 23, maxAge: 23, green: 12.6, yellow: 11.7 },
  { minAge: 24, maxAge: 24, green: 12.7, yellow: 11.7 },
  { minAge: 25, maxAge: 25, green: 12.7, yellow: 11.8 },
  { minAge: 26, maxAge: 26, green: 12.8, yellow: 11.8 },
  { minAge: 27, maxAge: 28, green: 12.9, yellow: 11.9 },
  { minAge: 29, maxAge: 30, green: 13, yellow: 12 },
  { minAge: 31, maxAge: 32, green: 13.1, yellow: 12.1 },
  { minAge: 33, maxAge: 33, green: 13.2, yellow: 12.1 },
  { minAge: 34, maxAge: 35, green: 13.2, yellow: 12.2 },
  { minAge: 36, maxAge: 36, green: 13.3, yellow: 12.2 },
  { minAge: 37, maxAge: 38, green: 13.3, yellow: 12.3 },
  { minAge: 39, maxAge: 40, green: 13.4, yellow: 12.3 },
  { minAge: 41, maxAge: 41, green: 13.4, yellow: 12.4 },
  { minAge: 42, maxAge: 44, green: 13.5, yellow: 12.4 },
  { minAge: 45, maxAge: 48, green: 13.6, yellow: 12.5 },
  { minAge: 49, maxAge: 51, green: 13.7, yellow: 12.6 },
  { minAge: 52, maxAge: 52, green: 13.8, yellow: 12.6 },
  { minAge: 53, maxAge: 54, green: 13.8, yellow: 12.7 },
  { minAge: 55, maxAge: 57, green: 13.9, yellow: 12.7 },
  { minAge: 58, maxAge: 60, green: 14, yellow: 12.8 },
];

export const getMuacColor = (age, muac, sex) => {
  if (age === "" || age === null || age === undefined || muac === "" || muac === null || muac === undefined) {
    return "";
  }

  const ageMonths = Number(age);
  const muacValue = Number(muac);
  if (!Number.isInteger(ageMonths) || !Number.isFinite(muacValue)) {
    return "";
  }

  const thresholdsBySex =
    sex === "1" ? boyMuacThresholds : sex === "2" ? girlMuacThresholds : null;
  if (!thresholdsBySex) return "";

  const thresholds = thresholdsBySex.find(
    ({ minAge, maxAge }) => ageMonths >= minAge && ageMonths <= maxAge
  );
  if (!thresholds) return "";

  if (muacValue >= thresholds.green) return "Green";
  if (muacValue >= thresholds.yellow) return "Yellow";
  return "Red";
};